
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs"
import { MemberButton } from "@/components/fun-ui/MemberButton";
import { cn } from "@/lib/utils";
import { usePayment } from "@/stores/appStore";
import { PaymentType } from "@/stores/slices/commonSlice";
import { DEFAULT_PAYMENT_TABS, PAYMENT_TAB_TRIGGER_MIN_WIDTH_PX } from "@/lib/payment";

export interface PaymentTabsProps extends React.PropsWithChildren {
  className?: string;
  /**
   * 与 PaymentDialog 的视口缩放一致；传 < 1 时 Tab 高度/字号同步缩小，为下方扫码区留出可视空间。
   * 定价页等全宽场景可省略，默认 1。
   */
  scale?: number;
}
export const PaymentTabs = ({
  children,
  className = '',
  scale = 1,
}: PaymentTabsProps) => {
  const {
    paymentType,
    setPaymentType,
  } = usePayment();

  const paymentTabs = DEFAULT_PAYMENT_TABS;
  const triggerGapPx = 4 * scale;
  const triggerPaddingXPx = 16 * scale;
  const tabsListPaddingXPx = 7 * scale;
  const tabsListDesignWidthPx =
    PAYMENT_TAB_TRIGGER_MIN_WIDTH_PX * paymentTabs.length * scale
    + triggerGapPx * Math.max(paymentTabs.length - 1, 0)
    + tabsListPaddingXPx * 2
    + triggerPaddingXPx * 2 * paymentTabs.length;

  return (
    <Tabs
      className={cn('relative flex h-full min-h-0 flex-1 flex-col', className)}
      style={{ gap: `${12 * scale}px` }}
      value={paymentType}
      onValueChange={(tab) => {
        setPaymentType(tab as PaymentType)
      }}>
      {
        paymentTabs.length > 1 && (
          <TabsList
            className={cn(
              '!h-auto min-h-0 !border-0 p-0 inline-flex w-full shrink-0 flex-row items-center justify-center self-center bg-[#DCE4F2]',
            )}
            style={{
              width: '100%',
              maxWidth: `${tabsListDesignWidthPx}px`,
              minHeight: `${54 * scale}px`,
              paddingTop: `${1 * scale}px`,
              paddingBottom: `${1 * scale}px`,
              paddingLeft: `${7 * scale}px`,
              paddingRight: `${7 * scale}px`,
              gap: `${4 * scale}px`,
              borderRadius: `${10 * scale}px`,
            }}
          >
            {
              paymentTabs.map(({ value, label }: { value: PaymentType; label: string }) => {
                const isMemberTab = value === 'upgrade' || value === 'upgradePlus3x';
                return (
                  <TabsTrigger
                    key={value}
                    className={cn(
                      "data-[state=active]:text-primary data-[state=active]:shadow-none data-[state=active]:rounded-md data-[state=inactive]:text-muted-foreground",
                      isMemberTab && paymentType === value && "data-[state=active]:bg-gradient-to-br data-[state=active]:from-[#a08669] data-[state=active]:to-[#553a20] data-[state=active]:text-[#EDDBC0]",
                      value === 'recharge' && paymentType === value && "data-[state=active]:text-primary-foreground data-[state=active]:bg-primary",
                      "h-10 flex-1 min-w-0 text-lg font-normal transition-none",
                      "focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0"
                    )}
                    style={{
                      height: `${40 * scale}px`,
                      paddingLeft: `${16 * scale}px`,
                      paddingRight: `${16 * scale}px`,
                      fontSize: `${16 * scale}px`,
                      lineHeight: `${22 * scale}px`,
                      borderRadius: `${8 * scale}px`,
                    }}
                    value={value}
                  >
                    {label}
                  </TabsTrigger>
                );
              })
            }
          </TabsList>
        )
      }
      {children}
    </Tabs>
  )
}